<template>
  <iColumn v-if="isOrgOwner || hasActiveExpertise">
    <iSubHeading>
      Areas of Expertise
    </iSubHeading>

    <iColumn v-if="isOrgOwner" gap="small" class="expertise-checkboxes">
      <iCheckbox
        v-for="area in expertiseAreas"
        :key="area.id"
        v-model="area.selected"
        :label="area.label"
        :is-loading="isLoadingToggleExpertiseArea(area.id)"
        @change="updateExpertiseArea(area.id)"
      />
    </iColumn>

    <iRow
      v-else-if="hasActiveExpertise"
      wrap="wrap"
      gap="small"
      width="fill"
    >
      <iTag
        v-for="area in activeExpertiseAreas"
        :key="area"
        :tag="area.label"
        :style-overrides="{fontSize: 'small', backgroundColor: 'informational'}"
      />
    </iRow>
  </iColumn>
</template>

<script>
import { EXPERTISE_AREAS } from "@/constants/expert-constants";
import { mapActions, mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import { useExpertServicePackageStore } from "@/stores/expert-service-package-store";

export default {
  name: "OrgAreasOfExpertise",
  props: {
    orgId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      expertiseAreas: EXPERTISE_AREAS.map(area => ({
        ...area,
        selected: false,
      })),
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["orgData"]),
    ...mapState(useExpertServicePackageStore, [
      "activeExpertIds",
      "currentExpertiseId",
      "isLoadingAddExpert",
      "isLoadingRemoveExpert",
    ]),
    isOrgOwner() {
      return this.orgId === this.orgData.org_id;
    },
    hasActiveExpertise() {
      return this.activeExpertIds.length > 0;
    },
    activeExpertiseAreas() {
      return this.expertiseAreas.filter(area => this.activeExpertIds.includes(area.id));
    },
  },
  mounted() {
    this.initializeExpertiseAreas();
  },
  methods: {
    ...mapActions(useExpertServicePackageStore, [
      "openExpertPackageModal",
      "addOrgExpertise",
      "removeOrgExpertise",
    ]),

    isLoadingToggleExpertiseArea(expertiseId) {
      const isCurrentExpertiseId = expertiseId === this.currentExpertiseId;
      return (
        isCurrentExpertiseId &&
          (this.isLoadingAddExpert || this.isLoadingRemoveExpert)
      );
    },

    initializeExpertiseAreas() {
      this.expertiseAreas.forEach(area => {
        area.selected = this.activeExpertIds.includes(area.id);
      });
    },

    updateExpertiseArea(expertId) {
      const area = this.expertiseAreas.find(area => area.id === expertId);
      if (area.selected) {
        this.addOrgExpertise(this.orgId, expertId);
      } else {
        this.removeOrgExpertise(this.orgId, expertId);
      }
    },
  },
};
</script>

